// Campaigns are email-only.
export type CampaignType = 'email'
export type LeadStatus = 'pending' | 'contacted' | 'snoozed'

export interface Lead {
  id: string
  name: string
  phone: string
  email: string
  loanAmount: number
  loanPurpose: 'Purchase' | 'Refinance'
  lastContact: string
  nextFollowUp: string
  campaignName: string
  campaignType: CampaignType
  status: LeadStatus
  ownerId: string
  ownerName: string
}

// Email campaigns a borrower can be enrolled into from the Follow-up Queue.
export const AVAILABLE_CAMPAIGNS = [
  'First-Time Buyer Nurture',
  'Rate Drop Alert',
  'Post-Closing Follow-up',
  'Pre-Approval Follow-up',
  'Cash-Out Refi Education',
]

export const USERS = [
  { id: 'admin', name: 'System Admin', role: 'admin' },
  { id: 'manager1', name: 'Sarah Manager', role: 'manager' },
  { id: 'manager2', name: 'David Director', role: 'manager' },
  {
    id: 'officer1',
    name: 'John Officer',
    role: 'officer',
    managerId: 'manager1',
  },
  {
    id: 'officer2',
    name: 'Jane Officer',
    role: 'officer',
    managerId: 'manager1',
  },
  {
    id: 'officer3',
    name: 'Mike Specialist',
    role: 'officer',
    managerId: 'manager2',
  },
]

export const MOCK_LEADS: Lead[] = [
  {
    id: 'L-1001',
    name: 'Sarah Jenkins',
    phone: '(555) 123-4567',
    email: 'sarah.j@example.com',
    loanAmount: 450000,
    loanPurpose: 'Purchase',
    lastContact: '2023-10-24T14:30:00Z',
    nextFollowUp: new Date().toISOString(),
    campaignName: 'First-Time Buyer Nurture',
    campaignType: 'email',
    status: 'pending',
    ownerId: 'officer1',
    ownerName: 'John Officer',
  },
  {
    id: 'L-1002',
    name: 'Michael Chen',
    phone: '(555) 987-6543',
    email: 'mchen88@example.com',
    loanAmount: 320000,
    loanPurpose: 'Refinance',
    lastContact: '2023-10-20T09:15:00Z',
    nextFollowUp: new Date().toISOString(),
    campaignName: 'Rate Drop Alert',
    campaignType: 'email',
    status: 'pending',
    ownerId: 'officer2',
    ownerName: 'Jane Officer',
  },
  {
    id: 'L-1003',
    name: 'Emily & David Rodriguez',
    phone: '(555) 456-7890',
    email: 'ed.rodriguez@example.com',
    loanAmount: 680000,
    loanPurpose: 'Purchase',
    lastContact: '2023-10-25T11:00:00Z',
    nextFollowUp: new Date().toISOString(),
    campaignName: '',
    campaignType: 'email',
    status: 'pending',
    ownerId: 'officer1',
    ownerName: 'John Officer',
  },
  {
    id: 'L-1004',
    name: 'James Wilson',
    phone: '(555) 222-3333',
    email: 'jwilson.tech@example.com',
    loanAmount: 510000,
    loanPurpose: 'Refinance',
    lastContact: '2023-10-22T16:45:00Z',
    nextFollowUp: new Date().toISOString(),
    campaignName: 'Cash-Out Refi Education',
    campaignType: 'email',
    status: 'contacted',
    ownerId: 'officer2',
    ownerName: 'Jane Officer',
  },
  {
    id: 'L-1005',
    name: 'Amanda Foster',
    phone: '(555) 777-8888',
    email: 'afoster22@example.com',
    loanAmount: 290000,
    loanPurpose: 'Purchase',
    lastContact: '2023-10-26T10:20:00Z',
    nextFollowUp: new Date().toISOString(),
    campaignName: '',
    campaignType: 'email',
    status: 'pending',
    ownerId: 'officer1',
    ownerName: 'John Officer',
  },
  {
    id: 'L-1006',
    name: 'Robert Taylor',
    phone: '(555) 111-2222',
    email: 'rtaylor@example.com',
    loanAmount: 420000,
    loanPurpose: 'Purchase',
    lastContact: '2023-10-27T09:00:00Z',
    nextFollowUp: new Date().toISOString(),
    campaignName: 'First-Time Buyer Nurture',
    campaignType: 'email',
    status: 'pending',
    ownerId: 'manager1',
    ownerName: 'Sarah Manager',
  },
]
